var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('kt-panel',[(_vm.status !== 'loading')?_c('kt-panel-body',[_c('product-form',{attrs:{"submit":_vm.updateProduct,"query":_vm.product}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }